export default __webpack_public_path__ + "static/media/hk417.6e5fd809.svg";